import { render, staticRenderFns } from "./SleepTestDetail.vue?vue&type=template&id=653abb02&scoped=true&"
import script from "./SleepTestDetail.vue?vue&type=script&lang=js&"
export * from "./SleepTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./SleepTestDetail.vue?vue&type=style&index=0&id=653abb02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653abb02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VImg,VRow})
